import React, { useState } from 'react'
import { css, useTheme } from '@emotion/react'
import Loading from './loading'

const titleStyle = theme => css({
    fontFamily: theme.fonts.secondary,
    fontSize: 13,
    fontWeight: 700,
    textTransform: 'capitalize',
    marginBottom: 16,
})

const inputStyle = theme => css({
    backgroundColor: 'transparent',
    border: `1px solid ${theme.colors.mutedDark}`,
    color: theme.colors.mutedLight,
    padding: '12px 12px 10px 12px',
    fontSize: 16,
    '::placeholder': {
        fontSize: 13,
    }
})

const googleStyle = theme => css({
    color: theme.colors.mutedLight, 
    textDecoration: 'underline',
})

export default function NewsletterSignup(){
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')
    const theme = useTheme()
    
    async function handleSubmit(e){
        e.preventDefault()
        e.stopPropagation()
        if (typeof window === `undefined`) return
        window.grecaptcha?.ready(async () => {
            try{
                setLoading(true)
                const token = await window.grecaptcha.execute('6LdPO7kZAAAAABGiIAZYVXsusLHXWuCCvJBJG5YU', { action: 'submit' })
                const formData = new FormData(e.target)
        
                const data = {
                    email: formData.get('email'),
                    firstName: '',
                    lastName: '',
                    title: '',
                    websiteID: 5908,
                    customerGroup: 'General',
                    gender: '',
                    dob: '',
                    SubscribedBrands: 'Moog',
                    company: null,
                    telephone: '',
                    country: '',
                    dataSource: 'Moog Website',
                    specialCategory: 0,
                    specialCategoryName: '',
                    user_response_token: token,
                }
        
                const options = {
                    headers: { "Content-Type": "application/json", },
                    method: "post",
                    body: JSON.stringify(data),
                }
                const SUITE_CRM_URL = 'https://crmtool.inmusicbrands.com/legacy/Api/index.php/custom/Signups'
                const r = await fetch(SUITE_CRM_URL, options)
                const d = await r.json()
        
                if(r.ok) {
                    setSuccess(d.message)
                } else {
                    throw new Error(d.error)
                }
            }
            catch (error) {
                setError(error.message)
                console.log(error)
            } finally {
                setLoading(false)
            }
        })
    }

    return(
        <div>
            <h6 css={titleStyle}>
                Get the latest moog news
            </h6>

            {
                loading
                ?
                <Loading />
                :
                success
                ?
                <p css={{ color: theme.colors.primary }}>
                    Thanks for signing up!
                </p>
                :
                <form onSubmit={handleSubmit}>
                    <input name='email' type='email' required placeholder='Enter Your Email Address' css={inputStyle} />
                    <input type='submit' css={[inputStyle, { 
                            fontSize: 16,
                            '&:hover, &:focus': {
                                cursor: 'pointer',
                                backgroundColor: theme.colors.primary,
                                color: 'black',
                            }
                        }]}
                    />
                </form>
            }

            {(error && typeof error === 'string') && <p css={{ color: 'red' }}>{error}</p>}

            <p css={{
                fontSize: 11,
                color: theme.colors.mutedLight,
            }}>
                This site is protected by reCAPTCHA and the Google<br />
                <a href="https://policies.google.com/privacy" css={googleStyle}>Privacy Policy</a>
                <span> and </span>
                <a href="https://policies.google.com/terms" css={googleStyle}>Terms of Service</a> apply.
            </p>
        </div>
    )
}
